import IztWaterfall from './src/izt-waterfall'

IztWaterfall.install = Vue => {
  Vue.component(IztWaterfall.name, IztWaterfall)
}

export default IztWaterfall